import { Component, input, output, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  visible = input<boolean>(false);
  title = input<string>('');
  width = input<string>('550px');
  modal = input<boolean>(true);
  draggable = input<boolean>(false);
  resizable = input<boolean>(false);
  closeOnEscape = input<boolean>(false);
  footerTemplate = input<TemplateRef<unknown> | null>(null);

  visibleChange = output<boolean>();
  close = output<void>();

  closeModal(): void {
    this.visibleChange.emit(false);
    this.close.emit();
  }
}
